import React, { useEffect , useState } from 'react';
import Brands from '../components/Brands';
import Projects from '../components/Projects';
import Testimonial from '../components/Testimonial';
import Hero from '../components/Hero';
import About from '../components/About';
import Service from '../components/Service';
// import HomePagdData from '../data/HomePagdData.json';
import Experience from '../components/Experience';
import Contact from '../components/Contact';
import Engagements from '../components/Engagements';
import Logins from "../components/Login";
import PlaylistPage from "../components/PlaylistPage";



export default function Device() {

    return (
        <>
            <PlaylistPage className="mt-40"/>
        </>
    );
}
